import { apiCallSPGet } from "./_apiConfig/apiCall";
import cgmfRoutes from "./routes";

const GetDynamicRoutes = async (role, menuList, roleMasterId) => {
  const getAllRights = async () => {
    if (roleMasterId > 0) {
      return await apiCallSPGet(`RoleRights?roleMasterId=${roleMasterId}`)
        .then(async (res) => {
          console.log(res);
          // if (res.success === false) {
          //   alert(res.message);
          // }
          return res.data;
        })
        .catch((error) => console.error("Error fetching data:", error));
    } else {
      return null; // Explicitly return null when roleMasterId is not greater than 0
    }
  };
  //console.log("eee", role, menuList);
  if (role === "CGMF") {
    //alert("cccddddddddddddd");
    const apiData = await getAllRights();
    const matched = apiData?.filter((apiItem) =>
      cgmfRoutes?.some(
        (existingItem) => existingItem.accessKey === apiItem.accessKey
      )
    );

    if (!apiData) {
      return []; // Return an empty array or handle this scenario appropriately
    } else {
      //console.log("matched : ", matched);
      return matched;
    }
  }

  // Assuming cgmfRoutes is an array
  const routes = []; //cgmfRoutes;

  return routes;
};

export default GetDynamicRoutes;
